module.exports = __webpack_public_path__ + "img/32302B_4C4842_121211_1C1C14-256px.c8b76a03.png";